export const CHANGE_DELIVERY_FORM_VALIDATION    = 'CHANGE_DELIVERY_FORM_VALIDATION';
export const CHANGE_PICKUP_FORM_VALIDATION      = 'CHANGE_PICKUP_FORM_VALIDATION';
export const SET_CATEGORY                       = 'SET_CATEGORY';
export const SET_RENTAL_PERIOD                  = 'SET_RENTAL_PERIOD';
export const SET_RENTAL_ID                      = 'SET_RENTAL_ID';